var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('crud-layout-search',{staticClass:"contact-client",attrs:{"params":_vm.params,"interface":_vm.nmInterface,"id":_vm.id,"page":_vm.page,"clean-layout":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }